<template>
    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
        <button class='ba-btn ba-md ba-blue' @click="goToSitemap(website)">
            <builderall-icon code='4970'></builderall-icon>
            {{ $t('ct-access-sitemap') }}
        </button>
    </div>
</template>

<script setup>
import {mapGetters} from 'vuex';
export default {
    methods: {
        goToSitemap(config) {
            if (config.status !== 'active')
                return;

            window.open('https://' + `${config.access_url}/sitemap.xml`, '_blank');
        },
    },
    computed: {
    ...mapGetters({website: 'website'}),
    }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/Sitemap.vue